var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rating !== null)?_c('div',{attrs:{"id":"main"}},[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"title-box"},[_c('span',[_vm._v("Rating")])])])],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-3",attrs:{"align-center":"","justify-center":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.displayRating))]),_vm._v(" "),_c('v-icon',{staticClass:"ml-3"},[_vm._v("star")])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57525946","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SharedComponents/RatingFrame.vue
// module id = 362
// module chunks = 0